<template>
    <div class="Itinerary-main">
        <div class="Itinerary-center">
            <div class="Itinerary-title">
                <div class="Itinerary-left">Itinerary</div>
                <div class="Itinerary-right">Expand All</div>
            </div>
            <div class="Itinerary-content">
                <div class="Itinerary-content-center" v-for="item in itinerary" :key="item.id">
                    <div class="Itinerary-content-item">
                        <div class="all"  @click="expandEvent(item.id)">
                            <div class="Itinerary-content-item-left">
                                {{item.market}}
                            </div>
                            <div class="Itinerary-content-item-right"
                            :style="{ transform: expandedItems[item.id] ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.8s ease-in-out' }"
                            >
                                 <!-- 根据展开状态显示加号或减号 -->
                                <img loading="lazy"  v-if="!expandedItems[item.id]" :src="add" alt="">
                                <img loading="lazy"  v-if="expandedItems[item.id]" :src="close" alt="">
                            </div>
                        </div>
                        <div class="all-content" :class="{'expand': expandedItems[item.id]}">
                            <div class="market-content">
                                <div class="market-banner">
                                    <loopSwiper :swiperList="item.marketImgList" @childSlideEvent="fatherSlideClickEvent"></loopSwiper>
                                </div>
                                <div class="market-title">
                                    {{item.marketTitle}}
                                </div>
                                <div class="market-desc">
                                    {{item.marketDesc}}
                                </div>
                            </div>
                            <locationContent 
                                @childLocationEvent="fatherLocationEvent"
                                :locationList="itinerary[item.id-1].location" 
                                v-if="itinerary[item.id-1].location.length > 0"
                                ></locationContent>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <maskSwiper 
            v-if="isMask"
            :swiperList="swiperImgList" 
            @childCloseEvent="fatherCloseEvent" 
            :swiperIndex="swiperIndex"
            :widthId="swiperType == 1 ? 1 :2"
        ></maskSwiper>
    </div>
</template>
<script>
import locationContent from '/components/pc/newProductDetils/locationContent'
import add from '/static/img/newProductDetils/add.png'
import close from '/static/img/newProductDetils/close.png'
import loopSwiper from '/components/pc/productDetailsSwiper/loopSwiper/loopSwiper.vue'
import maskSwiper from '/components/pc/productDetailsSwiper/maskSwiper/maskSwiper.vue'
    export default{
        components:{
            locationContent,
            loopSwiper,
            maskSwiper
        },
        props:{
            itinerary:Array,
        },
        data(){
            return {
                add:add,
                close:close,
                isExpand:false,
                itineraryActiveId:0,
                expandedItems: {},
                isMask:false,
                swiperIndex:0,
                swiperType:0,
            }
        },
        mounted(){//默认展开第一项
            if (this.itinerary && this.itinerary.length > 0) {
                this.expandEvent(this.itinerary[0].id);
            }
        },
        methods:{
            expandEvent(id){
                this.itineraryActiveId = id
                // 判断当前项的展开状态
                if (this.expandedItems[id] === undefined) {
                    // 如果没有记录展开状态，初始化为收起状态
                    this.$set(this.expandedItems, id, true);
                } else {
                    // 如果有记录展开状态，切换当前项的展开状态
                    this.$set(this.expandedItems, id, !this.expandedItems[id]);
                }
            },
            fatherSlideClickEvent(id,slides){
                this.isMask = true
                this.swiperImgList = slides
                this.swiperIndex = id-1
                this.swiperType = 1
            },
            fatherLocationEvent(index,list){
                this.isMask = true
                this.swiperImgList = list
                this.swiperIndex = index
                this.swiperType = 2
            },
            fatherCloseEvent(val){
                this.isMask = val
            }
        }
    }
</script>
<style scoped lang="scss">
    @import '/style/pc/newProductDetails/itineraryComponent.scss';
    @import '/style/phone/newProductDetils/itineraryComponent.scss';
    ::v-deep .el-carousel__arrow{
        background-color: rgba(0, 0, 0, 0.4) !important;
    }
    ::v-deep .el-carousel__arrow--right{
        font-size: 1.25rem;
        font-weight: 700;
    }
    ::v-deep .el-carousel__arrow--left{
       font-size: 1.25rem;
       font-weight: 700;
    }
    ::v-deep .el-carousel__arrow:hover{
        background-color: rgba(0, 0, 0, 0.5)!important;
    }
    ::v-deep .el-carousel--horizontal{
        border-radius: 0.75rem;
    }
</style>
